import { Inject,Injectable,InjectionToken } from '@angular/core';
// import { JwtHelperService } from '@auth0/angular-jwt';
import { OAuthService } from 'angular-oauth2-oidc';
import { IJsonAuthTokenViewModel as IJWT,UserViewModel } from '../view-models';
import { CommunityAuthService } from './community-auth.service';
import { ILogService } from './i';
import { LogServiceToken } from './log.service';

// Originally from http:// jasonwatmore.com/post/2016/08/16/angular-2-jwt-authentication-example-tutorial

@Injectable()
export class AuthenticationService {
  constructor(
    private oAuth: OAuthService,
    private communityAuth: CommunityAuthService,
    // private helper: JwtHelperService,
    @Inject(LogServiceToken) private log: ILogService
  ) {}
  // private decodedToken: any = null;
  get token(): string {
    return this.oAuth.getAccessToken();
  }
  get isAuthenticated(): boolean {
    return this.oAuth.hasValidAccessToken();
  }
  get username(): string {
    return (this.jsonToken && this.jsonToken.sub) || null;
  }
  get roles(): string[] {
    const user = this.getUserInfo<UserViewModel>();
    return user?.UserRoles?.map(r => r?.Role?.RoleName);
    /*return this.jsonToken && (typeof(this.jsonToken.role) === "string"
            ? [ this.jsonToken.role ]
            : this.jsonToken.role) || [];*/
  }
  get isSessionExpired(): boolean {
    return !this.oAuth.hasValidAccessToken();
  }
  // get isSessionExpired(): boolean { return this.oAuth.getAccessTokenExpiration() < Date.now(); }
  get sessionExpiration(): Date {
    return new Date(this.oAuth.getAccessTokenExpiration());
  }
  get jsonToken(): IJWT {
    return this.oAuth.getIdentityClaims() as IJWT;
  }
  get stateDescription(): string {
    if (this.token && this.isSessionExpired) {
      return 'Session expired.';
    } else if (this.isAuthenticated) {
      return 'Logged in.';
    } else {
      return 'Not logged in.';
    }
  }

  public getCurrentUserRoles(): string[] {
    const user = this.getUserInfo<UserViewModel>();
    return user?.UserRoles?.map(r => r?.Role?.RoleName) ?? [];
  }
  public getToken(): any {
    return this.token;
  }

  public getAccept(): string {
    return 'application/json';
  }

  public refresh() {
    this.oAuth.silentRefresh();
  }
  public hasValidToken() {
    return this.oAuth.hasValidAccessToken();
  }

  // These normally won't be exposed from a service like this, but
  // for debugging it makes sense.
  public get accessToken() {
    return this.oAuth.getAccessToken();
  }
  public get refreshToken() {
    return this.oAuth.getRefreshToken();
  }
  public get identityClaims() {
    return this.oAuth.getIdentityClaims();
  }
  public get idToken() {
    return this.oAuth.getIdToken();
  }
  public get logoutUrl() {
    return this.oAuth.logoutUrl;
  }

  authorizeRequest(headers: Headers): Headers {
    headers.append('Accept', 'application/json');
    headers.append('Authorization', 'Bearer ' + this.token);
    return headers;
  }
  hasRole(role: string): boolean {
    return (this.roles && this.roles.indexOf(role) !== -1) || false;
  }
  hasAnyRole(...rs: string[]): boolean {
    if (rs.length === 0) {
      return this.roles.length > 0;
    }

    return (
      this.roles && rs.filter(r => this.roles.indexOf(r) !== -1).length > 0
    );
  }
  hasAllRoles(...rs: string[]): boolean {
    if (rs.length === 0) {
      throw new Error(
        'No roles requested in order to be authorized. Is this a typo?'
      );
    }
    return (
      this.roles &&
      rs.filter(r => this.roles.indexOf(r) !== -1).length === rs.length
    );
  }
  beginLoginFlow(): void {
    this.oAuth.initCodeFlow();
  }
  checkForLogin(): Promise<IJWT> {
    return this.oAuth
      .tryLoginCodeFlow()
      .then(() => <any>this.oAuth.getIdentityClaims());
  }
  setUserInfo<T>(user: T): void {
    localStorage.setItem('userInfo', JSON.stringify(user));
  }
  getUserInfo<T>(): T {
    const user = localStorage.getItem('userInfo');
    try {
      return JSON.parse(user);
    } catch (err) {
      return null;
    }
  }
  async logout() {
    await this.communityAuth.logout();
  }
}

export const AuthenticationServiceToken = new InjectionToken(
  'IAuthenticationServiceToken'
);
